import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

export const useGlobalHeaderStyles = makeStyles(
  (theme: Theme) => {
    return {
      headerContainer: {
        display: 'flex',
        padding: '.5rem 1rem',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: theme.palette?.mode === 'dark' ? '#424242' : '#FFF',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        height: '64px',
        borderBottom:
          theme.palette?.mode === 'light'
            ? '1px solid #E1E3E5'
            : '1px solid var(--xlrt-color-ui-gray40)',
      },
      logoContainer: {
        display: 'flex',
      },
      searchContainer: {
        display: 'flex',
        gap: '0.25rem',
      },
      actionContainer: {
        display: 'flex',
        gap: '.75rem',
        alignItems: 'center',
      },
      createEntity: {
        display: 'flex',
        padding: '.5rem .75rem .5rem .5rem',
        alignItems: 'center',
        gap: '0.25rem',
        alignSelf: 'stretch',
        borderRadius: '1000px',
        background:
          theme.palette?.mode === 'dark'
            ? 'var(--xlrt-color-future-green500)'
            : 'var(--xlrt-color-future-green800)',
        textTransform: 'none',
        boxShadow: 'none',
        '&:hover': {
          background:
            theme.palette?.mode === 'dark'
              ? 'var(--xlrt-color-future-green500)'
              : 'var(--xlrt-color-future-green800)',
          boxShadow: 'none',
        },
        '& .v5-MuiButton-startIcon': {
          margin: '0',
        },
      },
      linkButtons: {
        color: theme.palette?.mode === 'dark' ? '#B6B5B6' : '#9D9EA6',
        padding: '0',
        minWidth: '0',
        '& .MuiButton-startIcon': {
          margin: '0',
        },
        '& .v5-MuiButton-icon': {
          margin: '0',
        },
        '&:hover': {
          background: 'inherit',
          color: theme.palette.mode === 'light' ? '#74757E' : '#FFFFFF',
          textDecoration: 'none',
        },
      },

      supportContainer: {
        position: 'absolute',
        top: '2.188rem',
        right: '.125rem',
        zIndex: 1000,
      },
      commonContainer: {
        position: 'relative',
      },
    };
  },
  { name: 'GlobalHeader' },
);
